const accountTypes = {
  ads: 'ads',
  email: 'email',
};

export default accountTypes;
